import { Image, View } from '@react-pdf/renderer';
import { useEffect, useMemo, useState } from 'react';
import { InvoiceInterface } from '../../../../interfaces/invoice.interface';
import { getAadeQrUrl } from '../../../../services/utils/myDataUtils';
import { getQRDataUrl } from '../../../../services/utils/pdf';

interface Props {
  doc: InvoiceInterface;
}

// Split out of `PdfAadeData.tsx` so it can be placed next to `PdfNotes` in normal content flow
// instead of the page-edge-pinned `footer` View — that absolute positioning was clipping the QR
// on print, making it unscannable.
export const PdfQrCode = ({ doc }: Props) => {
  const qrText = useMemo(() => getAadeQrUrl(doc), [doc]);
  const [qr, setQr] = useState<null | string>(null);

  useEffect(() => {
    const createQrData = async () => {
      const qrData = await getQRDataUrl(qrText);

      if (qrData) setQr(qrData);
    };

    createQrData();
  }, [qrText]);

  if (!doc?.sentToAade || !qr) return null;

  return (
    <View style={{ height: 56, width: 56 }}>
      <Image src={qr} style={{ height: 56, width: 56, borderWidth: 1 }} />
    </View>
  );
};
